import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useSearchParams } from "react-router-dom";
import { useAuthYaMutation } from "../../api/main/user";

function ExternalAuthYa() {
  //https://user-office.ru/auth/ya?code=zy2otzby42iogcr4&cid=ze5yur3urg41ukqtpt4n12rwt4
  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [authSuccess, setAuthSuccess] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");
  const device_id = searchParams.get("device_id");
  const state = searchParams.get("state");

  const [authYaApi] = useAuthYaMutation();

  const [cookiesPromo, setCookiePromo, removeCookiePromo] = useCookies(['biz_promo']);
  const [cookies, setCookie, removeCookie] = useCookies(['biz_outh_srv']);

  useEffect(() => {
    setLoading(true);
    authYaApi({ device_id: device_id, code: code, state: state, promo: cookiesPromo.biz_promo })
      .unwrap()
      .then((res) => {
        if (res.Status !== 1) {
          setLog(res.Error);
          setLoading(false);
        }
        else {
          setAuthSuccess(true);
          const srv = cookies.biz_outh_srv;
          if (srv === 2) {
            return window.location.replace(process.env.REACT_APP_DOMAIN_TRACKER + '/lk');
          }
        }
      })
      .catch((err) => {
        setLog('Неизвестная ошибка!');
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className="row mt-5 mb-5">
        <div className="col-lg-12 text-center">
          <h1>Авторизация Yandex ID</h1>
        </div>
      </div>

      {loading === true && (
        <div className="row mt-5 mb-5">
          <div className="col-lg-12 text-center log_form">
            <span className="loader_01"></span>
          </div>
        </div>
      )}
      {log !== null && (
        <div className="row mt-5 mb-5">
          <div className="col-lg-12 text-center log_form">
            {log}
          </div>
        </div>
      )}
      {authSuccess === true && (
        <>
          <div className="row mt-5 mb-5">
            <div className="col-lg-4">

            </div>
            <div className="col-lg-4 text-center text-success">
              Успешная авторизация. Для продолжения выберите сервис:
            </div>
            <div className="col-lg-4">

            </div>
          </div>
          <div className="row mt-5 mb-5">
            <div className="col-lg-4">

            </div>
            <div className="col-lg-4">
              <h1 className="text-center mt-5">Вы вошли</h1>
              <div className="text-center mt-2">Выберите сервис для входа:</div>
              <div className="srv_block mt-5">
                <a href={process.env.REACT_APP_DOMAIN_TRACKER + "/lk"}>
                  <div className="srv_card">
                    <div className="header">Трекер задач</div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-lg-4">

            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ExternalAuthYa;